// ONB-PARENT: the registered steps. ONB-1 ships the shell and the gate only: NO step is registered, so the wizard cannot show yet.
// ONB-2 (profile + language), the child step, ONB-3 (notifications), ONB-5 (co-parent) and ONB-4 (calendar, behind a flag) add their modules here.
import { profileStep } from './step-profile.js';
import { childStep } from './step-child.js';
import { notificationsStep } from './step-notifications.js';
import { coparentStep } from './step-coparent.js';
import { googleStep } from './step-google.js';
export function registerAll(register) {
  register(profileStep);   // ONB-2: profile + language
  register(childStep);     // the child step: only for a primary parent with no child yet
  register(notificationsStep);   // ONB-3: notifications (the browser prompt fires on Next)
  register(googleStep);          // ONB-4: calendar sync (popup sign-in); applicable() is false while GOOGLE_STEP.enabled is false (the flag ships OFF)
  register(coparentStep);        // ONB-5: invite a co-parent (e-mail only)
  /* the child step, ONB-3 notifications, ONB-5 co-parent and ONB-4 calendar (behind a flag) register here */
}
